import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IManageColumnInterface } from '../../model/commonModel';
import { ApiService } from '../../services/api.service';
import { ApiUrlHelper } from '../../services/api-url-helper/api-url-helper';

@Component({
  selector: 'app-manage-column',
  templateUrl: './manage-column.component.html',
  styleUrl: './manage-column.component.scss',
})
export class ManageColumnComponent {
  selectedColumns: IManageColumnInterface[] = [];

  constructor(
    public dialogRef: MatDialogRef<ManageColumnComponent>,
    private apiService: ApiService,
    private urls: ApiUrlHelper,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.selectedColumns = JSON.parse(JSON.stringify(data.columns));
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
  applyChanges(): void {
    if (this.data?.listName) {
      const payload = {
        ListName: this.data.listName,
        SelectedColumns: JSON.stringify(this.selectedColumns),  
      };

      let apiUrl = this.urls.apiUrl.common.saveColumnPreferences;

      this.apiService.doPost(apiUrl, payload).subscribe({
        next: (res) => {
          if (res?.Success) {
            this.dialogRef.close(this.selectedColumns); // return updated list
          } else {
            console.error('Failed to save preferences');
          }
        },
        error: (err) => {
          console.error('Error saving preferences', err);
        },
      });
    } else {
      this.dialogRef.close(this.selectedColumns);
    }
  }
}
